import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { AuthGuard } from '@app/guards/auth.guard';
import { ProgramListComponent } from './program-list.component';
import { ListOfProgramsComponent } from './list-of-programs/list-of-programs.component';
import { CurrentContextResolver } from '@app/context-resolver/context-resolver';

// Note that this route is the same as for Spaces.
// This one is only reached if the hub is a program hub because the routes for in WondaModule take priority.
const routes = [
  {
    path: ':urlTitle',
    component: ProgramListComponent,
    resolve: { context: CurrentContextResolver },
    canActivate: [AuthGuard]
  }
];

@NgModule({
  declarations: [
    ProgramListComponent,
    ListOfProgramsComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
    SharedModule,
  ]
})
export class ProgramListModule { }
